import { io } from 'socket.io-client';
import { resolveBrowserNetworkUrl } from './utils/runtimeUrl';

let socket;
let wakeListenersAttached = false;

// Mobile/tablet browsers suspend JS timers on backgrounded tabs or a locked screen,
// which can stall socket.io's own reconnection backoff indefinitely. Force a manual
// reconnect attempt whenever the page becomes visible/active again so long-lived
// "remote display" screens don't silently drop out and stay disconnected forever.
function attachWakeListeners() {
  if (wakeListenersAttached || typeof document === 'undefined') return;
  wakeListenersAttached = true;

  const kickReconnect = () => {
    if (socket && !socket.connected) socket.connect();
  };

  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') kickReconnect();
  });
  window.addEventListener('pageshow', kickReconnect);
  window.addEventListener('online', kickReconnect);
  window.addEventListener('focus', kickReconnect);
}

export function getSocket() {
  if (!socket) {
    let socketUrl = process.env.REACT_APP_URL;

    try {
      socketUrl = new URL(process.env.REACT_APP_URL).origin;
    } catch (e) {
      socketUrl = process.env.REACT_APP_URL || window.location.origin;
    }

    socketUrl = resolveBrowserNetworkUrl(socketUrl);

    socket = io(socketUrl, {
      transports: ['polling', 'websocket'],
      upgrade: true,
      reconnection: true,
      reconnectionAttempts: Infinity,
      reconnectionDelay: 1000,
      reconnectionDelayMax: 5000,
    });
    attachWakeListeners();
  }

  return socket;
}
